<template src="./form.html"></template>

<script>
import { CreateVariable } from '@/api/variable'

export default {
  name: 'add-variable',
  data: function () {
    return {
      model: {
        domainid: this.meta,
        order: '',
        var: null,
        label: null,
        type: null,
        unit: null,
        codelist: null,
        width: null
      },
      types: {
        'text': '短文本',
        'long': '长文本',
        'int': '整数',
        'float': '小数',
        'radio': '单选',
        'checkbox': '多选',
        'date': '日期',
        'datetime': '日期时间',
        'time': '时间'
      },
      widths: {
        6: 6,
        8: 8,
        12: 12,
        16: 16,
        18: 18,
        24: 24
      },
      ruleValidate: {
        variable: [{
          required: true,
          message: '访视不能为空',
          trigger: 'change'
        }],
        label: [{
          required: true,
          message: '标签不能为空',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '类型不能为空',
          trigger: 'change'
        }],
        order: [{
          required: true,
          type: 'number',
          message: '顺序不能为空',
          trigger: 'change'
        }]
      }
    }
  },
  props: ['meta'],
  methods: {
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      CreateVariable(this.model).then(async res => {
        if (res.id) {
          this.$Message.success('已添加到成员列表！')
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
